import { NgIf, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-settings-navigation',
  templateUrl: 'settings-navigation.component.html',
  imports: [MatTabNav, MatTabLink, RouterLink, NgIf, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class SettingsNavigationComponent {
  routeUrl$: Observable<string> = this.store.select(RouterSelectors.getPath);

  isUomSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('uom-setting') > 0),
  );
  isBarn$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('barn') > 0));
  isDiscount$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('discount') > 0));

  isAtLeastAdmin$: Observable<boolean> = this.store.select(
    AuthorizationSelectors.hasAtLeastAdministratorRole,
  );

  isDosatorSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('dosator-setting') > 0),
  );

  constructor(private readonly store: Store<RootState>) {}
}
